import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import Img from '../../../Img';
import { getApiAxiosInstance } from '../../../../utils/network';
import { getApiErrorMessage } from '../../../../utils/apiError';
import { showSuccessToast } from '../../../../actions/notification-actions';
import {
    TARGET_COLLEGE_ADDED_TOAST_TITLE,
    buildTargetCollegeAddedMessage,
} from './targetCollegeToast';
import styles from '../collegeCoachActivity.scss';

const TARGET_COLLEGES_ENDPOINT = '/v1/cpp/target-colleges';
const ADD_ICON_SRC = '/img/v3/icons/icon-18px-circle-plus-teal.svg';

const AddToTargetListButton = ({
    clubId,
    collegeName,
    addedClubIds,
    onSuccess,
    onError,
    'data-testid': dataTestId,
}) => {
    const dispatch = useDispatch();
    const [isAdding, setIsAdding] = useState(false);
    const [isAddedLocal, setIsAddedLocal] = useState(false);

    const isControlled = addedClubIds !== null;
    const isAdded = isControlled ? addedClubIds.has(clubId) : isAddedLocal;

    const handleClick = async () => {
        if (!clubId || isAdding || isAdded) {
            return;
        }
        setIsAdding(true);
        try {
            await getApiAxiosInstance().post(TARGET_COLLEGES_ENDPOINT, { clubId });
            if (!isControlled) {
                setIsAddedLocal(true);
            }
            dispatch(showSuccessToast({
                title: TARGET_COLLEGE_ADDED_TOAST_TITLE,
                message: buildTargetCollegeAddedMessage(collegeName),
            }));
            if (onSuccess) {
                onSuccess(clubId);
            }
        } catch (err) {
            if (onError) {
                onError(getApiErrorMessage(err, 'We couldn\'t add that college.'));
            }
        } finally {
            setIsAdding(false);
        }
    };

    const isDisabled = isAdded || isAdding;

    return (
        <button
            type="button"
            className={styles.addButton}
            onClick={handleClick}
            disabled={isDisabled}
            aria-label={isAdded ? 'Already in target list' : 'Add to target list'}
            data-testid={dataTestId}
        >
            <Img
                src={ADD_ICON_SRC}
                alt=""
                className={styles.addIcon}
            />
        </button>
    );
};

AddToTargetListButton.defaultProps = {
    collegeName: null,
    addedClubIds: null,
    onSuccess: null,
    onError: null,
    'data-testid': null,
};

AddToTargetListButton.propTypes = {
    clubId: PropTypes.number.isRequired,
    collegeName: PropTypes.string,
    addedClubIds: PropTypes.instanceOf(Set),
    onSuccess: PropTypes.func,
    onError: PropTypes.func,
    'data-testid': PropTypes.string,
};

export default AddToTargetListButton;
